'use client'
import { guestParamsQueryOptions } from '@/features/account/services/GuestUser/queryOptions'
import { useQueryUser } from '@/features/account/services/User/queries'
import { selectedUserGroupQueryOptions } from '@/features/account/services/Business/queryOptions'
import { inferredZipQueryOptions } from '@/features/account/services/Zip/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { useQueryAuth0User } from '@/features/authentication/services/Authentication/queries'
import { zipUserStoreQueryOptions } from '@/features/shop/services/ShoppingStore/queryOptions'

export const SessionQueryControllers = () => {
  useQueryAuth0User()
  useQueryUser()
  useQuery(selectedUserGroupQueryOptions)
  useQuery(inferredZipQueryOptions)
  useQuery(guestParamsQueryOptions)
  useQuery(zipUserStoreQueryOptions)

  return null
}
